import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import BatteryForm from '../../../components/forms/BatteryForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import GetAction from '../../../actions/batteries/GetAction'
import PutAction from '../../../actions/batteries/PutAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class UpdateBatteryPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.get(this.props.id)
  }

  componentDidUpdate(prevProps, prevState) {
    // If fetch is error, close with error
    if (
      prevProps.isLoading
      &&
      !this.props.isLoading
      &&
      this.props.loadError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.FAILURE, "Impossible d'obtenir les infos sur ce modèle de batterie.")
      this.props.onClose(false)
    }

    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.saveError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Modèle de batterie modifié.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.put(this.props.id, data)
  }

  render() {
    return (
      <Popup
        header='Modifier un modèle de batterie'
        body={
          <BatteryForm
            data={this.props.data}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={this.props.isLoading}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.saveError}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Modifier',
            color: 'orange',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isLoading={this.props.isLoading}
        isSaving={this.props.isSaving}
      />
    )
  }
}

UpdateBatteryPopup.propTypes = {
  // Properties
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  data: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  loadError: PropTypes.object,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,

  // Redux Actions
  get: PropTypes.func.isRequired,
  put: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    data: state.entities.batteries.get.data,
    isLoading: state.entities.batteries.get.isFetching,
    loadError: state.entities.batteries.get.error,
    isSaving: state.entities.batteries.put.isFetching,
    saveError: state.entities.batteries.put.error
  }),
  (dispatch) => ({
    get: (id) => (dispatch(GetAction({ id }))),
    put: (id, data) => (dispatch(PutAction({ id, data }))),
    clearError: () => (dispatch(ClearErrorAction(Types.BATTERIES.PUT)))
  })
)(UpdateBatteryPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/batteries/UpdateBatteryPopup.js